import React from 'react'
import logo from './logo.svg'
import './App.css'
import Auth from './components/Auth'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <div>BOOKING</div>
        <Auth />
      </header>
    </div>
  )
}

export default App
